import React from 'react';
import questionIcon from '@/public/images/icons/question-mark.svg';
import { useLocalization } from '@/services/localizationService';
import { EditorButtonType } from './editorButtonTypes';
import { Tooltip } from '../tooltip';
import { Badge } from '../badge';

interface Props extends EditorButtonType {
  children?: React.ReactNode;
  isBadgeHidden?: boolean;
}

export default function EditorButton({
  id,
  label,
  active,
  disabled,
  badge,
  infoBadge,
  isBadgeHidden,
  onClick,
}: Props) {
  const { data } = useLocalization();
  const badgeLabel = badge
    ? data.common[badge.label] || data.result[badge.label] || badge.label
    : '';
  return (
    <button
      key={id}
      id={id}
      type="button"
      className={`btn text-sm me-2 mb-2 min-w-[46px] z-9 px-3.5 h-[44px] relative hover:bg-overlay-white-15 border-2 bg-black border-overlay-white-15 rounded-[8px] ${
        disabled ? 'text-gray-400 pointer-events-none' : ''
      } ${active ? 'bg-overlay-white-15 border-transparent' : ''}`}
      onClick={onClick}
    >
      {badge && (
        <Badge
          id={badge.id}
          hidden={isBadgeHidden}
          label={badgeLabel}
          className="w-max"
        />
      )}
      <p className="SB14">{label}</p>
      {infoBadge && (
        <div className="info-badge max-w-[24px]">
          <img className="peer" {...questionIcon} alt="info icon" />
          <Tooltip
            className="opacity-0 peer-hover:opacity-100 transition-all w-[100px] tooltip"
            visible
            tooltipContentClassName="font-semibold"
            content={infoBadge.tooltip}
            position="bottom"
          />
        </div>
      )}
    </button>
  );
}
